<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">
        {{ 'sharedModule.bkgSummaryLocation.location' | translate }}
      </h3>
      <button
        (click)="onClickClose()"
        type="button"
        class="modal__close"
        data-bs-dismiss="modal"
        attr.aria-label="{{ 'common.close' | translate }}"
      >
        <img src="assets/images/icons/close.svg" alt="" />
      </button>
    </div>

    <div class="modal__body">
      <bkg-gmaps [mapConfig]="gmapConfig"></bkg-gmaps>
    </div>
    <div *ngIf="gmapsLink" class="modal__body">
      <a [href]="gmapsLink" target="_blank">{{
        'sharedModule.bkgSummaryLocation.howToGet' | translate
      }}</a>
    </div>
  </div>
</div>
